<div class="customer_tab">
    <mat-tab-group
      animationDuration="0ms"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab [ngClass]="checkAvailableDay('Sunday') ? 'available' : 'unAvailable'">
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Sunday') ? 'available' : 'unAvailable'">
          </div>
          <span>Sunday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
            <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Sunday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
          </div>
          
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Sunday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Sunday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Sunday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Sunday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
        
      
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Monday') ? 'available' : 'unAvailable'">
          </div>
          <span>Monday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
            <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Monday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
          </div>
         
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Monday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Monday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Monday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Monday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
       
       
       </mat-tab>
       <mat-tab>
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Tuesday') ? 'available' : 'unAvailable'">
          </div>
          <span>Tuesday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
            <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Tuesday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
          </div>
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Tuesday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Tuesday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Tuesday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Tuesday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
        
        
       </mat-tab>
       <mat-tab>
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Wednesday') ? 'available' : 'unAvailable'">
          </div>
          <span>Wednesday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
            <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Wednesday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
          </div>
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Wednesday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Wednesday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Wednesday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Wednesday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
       
        
       </mat-tab>
       <mat-tab>
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Thursday') ? 'available' : 'unAvailable'">
          </div>
          <span>Thursday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
          <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Thursday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
          </div>
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Thursday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Thursday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Thursday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Thursday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
        
       
       </mat-tab>
       <mat-tab>
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Friday') ? 'available' : 'unAvailable'">
          </div>
          <span>Friday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
            <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Friday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
          </div>
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Friday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Friday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Friday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Friday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
        
        
       </mat-tab>
       <mat-tab>
        <ng-template mat-tab-label>
          <div [ngClass]="checkAvailableDay('Saturday') ? 'available' : 'unAvailable'">
          </div>
          <span>Saturday</span> 
        </ng-template>
        <div class="panel">
          <div class="table_panel">
            <div class="schedule_time">
              <fury-time-scheduler-table [displayedColumns]="displayedColumns" [dataSource]="[scheduleGridValues?.Saturday]" [clearCellSelection]="clearCellSelection" (checkSchedule)="checkSchedule($event)"></fury-time-scheduler-table>
            </div>
          </div>
          <div *ngIf="selectedCellValue?.isSelected" (click)="clearSelection()" class="btn_prt">
            <span title="Update" *ngIf="selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(false, 'Saturday')" class="update"><mat-icon>create</mat-icon></span>
            <span title="Delete" *ngIf="selectedCellValue?.endTime" (click)="deleteTimeSlot('Saturday')" class="delete"><mat-icon>delete</mat-icon></span>
            <span title="Add" *ngIf="!selectedCellValue?.isScheduled && !selectedCellValue?.endTime" (click)="handleAddEditTimeScheduleModal(true, 'Saturday')" class="add"><mat-icon>add_circle_outline</mat-icon></span>
            <span (click)="resetTimeSchedule('Saturday')" title="Reset" class="add"><mat-icon>refresh</mat-icon></span>
          </div>
        </div>
       
        
       
       </mat-tab>
    </mat-tab-group>
  </div>
  